import React from 'react';
import PropTypes from 'prop-types';
import styles from './RadioButton.module.css';

export const labelPositions = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  HIDDEN: 'HIDDEN',
};

const propTypes = {
  ariaLabel: PropTypes.string,
  ariaLabelledby: PropTypes.string,
  label: PropTypes.string,
  labelPosition: PropTypes.oneOf([labelPositions.RIGHT, labelPositions.LEFT, labelPositions.HIDDEN]),
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default function RadioButton(props) {
  const { ariaLabel, ariaLabelledby, label, labelPosition, onChange, ...radioButtonProps } = props;

  const getContainerClasses = () => {
    const suppliedClasses = radioButtonProps.className ? radioButtonProps.className : '';
    switch (labelPosition) {
      case labelPositions.LEFT:
        return `${suppliedClasses} ${styles.container} ${styles['label-on-left']}`;
      case labelPositions.HIDDEN:
        return `${suppliedClasses} ${styles.container} ${styles['hide-label']}`;
      default:
        return `${suppliedClasses} ${styles.container}`;
    }
  };

  const getAriaProps = () => {
    const properties = {};
    if (ariaLabelledby) {
      properties['aria-labelledby'] = ariaLabelledby;
    }
    if (ariaLabel) {
      properties['aria-label'] = ariaLabel;
    }
    if (!ariaLabelledby && !ariaLabel) {
      properties['aria-label'] = label;
    }
    return properties;
  };

  return (
    <label className={getContainerClasses()}>
      <input
        checked={false}
        {...getAriaProps()}
        {...radioButtonProps}
        type="radio"
        className={styles.toggle}
        onChange={onChange}
      />
      <span className={styles.label} aria-hidden="true">
        {label}
      </span>
    </label>
  );
}

RadioButton.defaultProps = {
  label: '',
  labelPosition: labelPositions.RIGHT,
  onChange: () => {},
};

RadioButton.propTypes = propTypes;
